import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    imports: [
        TranslatePipe,
    ],
})
export class HeaderComponent {
    @Input() label!: string;
    @Input() icon: string | null = null;
}
